__turbopack_context__.v({
  "button": "NewsletterSection-module-scss-module__pWQCnq__button",
  "form": "NewsletterSection-module-scss-module__pWQCnq__form",
  "formWrapper": "NewsletterSection-module-scss-module__pWQCnq__formWrapper",
  "input": "NewsletterSection-module-scss-module__pWQCnq__input",
  "pending": "NewsletterSection-module-scss-module__pWQCnq__pending",
  "popoverContainer": "NewsletterSection-module-scss-module__pWQCnq__popoverContainer",
});
